import InnerWrapper from '../InnerWrapper'
import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'
import Modal from 'components/Modal'
import TSTable from 'components/Tanstack'

import ContactUpdateModalForm from './ContactUpdateModalForm/Form'
import Actions from './Actions'
import { useCorporateContacts } from './useCorporateContacts'
import { useCorporateContactsTable } from './useCorporateContactsTable'

const Index = (): JSX.Element => {
  const { corporateContacts, corporateContactsModStatus } = useCorporateContacts()

  const {
    corporateContactsActionModal,
    corporateContactsSelected,
    corporateContactsTableData,
    corporateContactsTableColumns,
    handleCorporateContactsActionModalClose,
  } = useCorporateContactsTable()

  return (
    <>
      <InnerWrapper title="Contacts">
        <div className="flex justify-end mb-4">
          <Actions />
        </div>

        {corporateContactsModStatus === 'fail' ? (
          <NoResults
            header="Failed to load data"
            subtitle="Please refresh the page and try again, or contact your system administrator"
            noImage
          />
        ) : null}

        {corporateContactsModStatus === 'loading' ? <Spinner /> : null}

        {corporateContacts.length && corporateContactsModStatus === 'success' ? (
          <TSTable.Table
            data={corporateContactsTableData}
            columns={corporateContactsTableColumns}
          />
        ) : null}

        {!corporateContacts.length && corporateContactsModStatus === 'success' ? (
          <NoResults
            header="No available data"
            subtitle="There is no available data to display"
            noImage
          />
        ) : null}
      </InnerWrapper>

      {corporateContactsActionModal === 'corporate_contacts_update' &&
      corporateContactsSelected ? (
        <Modal
          open={true}
          title="Update Contact"
          onClose={handleCorporateContactsActionModalClose}
          noFooter
        >
          <ContactUpdateModalForm
            onCloseModal={handleCorporateContactsActionModalClose}
            selectedCorporateContact={corporateContactsSelected}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default Index
